import { EnumTipoOrdenacaoNovaGuia } from "../enums/EnumTipoOrdenacaoNovaGuia";
import { ItemLookupOrdenacaoNovaGuia } from "../models/lei/item.lookup.ordenacao.nova.guia";

export const modosOrdenacao: ItemLookupOrdenacaoNovaGuia[] = [
  {
    label: "Ordem alfabética",
    ordenacao: EnumTipoOrdenacaoNovaGuia.OrdemAlfabetica,
  },
  { label: "Mais lidos", ordenacao: EnumTipoOrdenacaoNovaGuia.MaisLidos },
  { label: "Menos lidos", ordenacao: EnumTipoOrdenacaoNovaGuia.MenosLidos },
  {
    label: "Data de alteração",
    ordenacao: EnumTipoOrdenacaoNovaGuia.DataAlteracao,
  },
];
